module.exports = __webpack_public_path__ + "img/poster_scales-to-infinity.de034095.jpg";